import { getCharacterArt } from "../assets/CharacterArt.js";

function normalizeId(id) {
  return String(id || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

export function getSpeakerName(speakerId) {
  const id = normalizeId(speakerId);
  return (
    {
      narrator: "NARRATOR",
      admiralbulldog: "ADMIRAL BULLDOG",
      admiralbloodhound: "ADMIRAL BULLDOG",
      admiral: "ADMIRAL BULLDOG",
      logi7: "LOGI-7",
      civilianpilot: "CIVILIAN PILOT",
      acquisitioncaptain: "ACQUISITION CAPTAIN",
      marketmakeromega: "MARKET MAKER OMEGA",
      honeybadger: "RAGEBURROW",
      octopus: "MULTIVEIL",
      elephant: "GRAY MATTER",
      mantisshrimp: "CHROMA WAR",
      ant: "FULFILLMENT QUEEN",
    }[id] || String(speakerId || "UNKNOWN").toUpperCase()
  );
}

export function getSpeakerModelUrl(speakerId) {
  const id = normalizeId(speakerId);
  const art = getCharacterArt(id);
  return art?.fullProfileGlbUrl || art?.characterGlbUrl || null;
}

export function getSpeakerCinematicModelUrl(speakerId) {
  const id = normalizeId(speakerId);
  const art = getCharacterArt(id);
  return art?.cinematicProfileGlbUrl || art?.fullProfileGlbUrl || art?.characterGlbUrl || null;
}

export function getOpeningCinematicSteps() {
  return [
    {
      kind: "card",
      title: "BLACK SCREEN",
      lines: ["IN THE YEAR 20XX…", "CAPITALISM LEFT EARTH.", "IT GOT WORSE."],
    },
    {
      kind: "narration",
      title: "SPACE PAN",
      note: "Cargo lanes. Freight fleets. Explosions.",
      speakerId: "narrator",
      text: "In the far reaches of the galaxy… trade became war.",
    },
    {
      kind: "narration",
      title: "SHORT SELLERS REVEAL",
      note: "Enemy ships swarm past camera.",
      speakerId: "narrator",
      text: "The Short Seller Syndicate seized control of shipping lanes… markets… and lunch breaks.",
    },
    {
      kind: "narration",
      title: "CIVILIAN CHAOS MONTAGE",
      note: "Fuel prices spike. Package delayed notices. Vending machine riots. Elderly woman punching kiosk.",
      speakerId: "narrator",
      text: "Entire systems suffered shortages… inflation… and premium convenience fees.",
    },
    {
      kind: "narration",
      title: "HERO REVEAL",
      speakerId: "narrator",
      text: "The Galactic Council needed heroes.\n\nThey hired contractors.",
    },
    { kind: "dialogue", speakerId: "honeybadger", note: "Crashes ship into hangar wall.", text: "Did we win?" },
    { kind: "dialogue", speakerId: "octopus", note: "Signs eight contracts.", text: "I now own twelve percent of this mission." },
    { kind: "dialogue", speakerId: "elephant", note: "Reads safety binder.", text: "I have identified several immediate concerns." },
    { kind: "dialogue", speakerId: "mantisshrimp", note: "Dramatic spotlight.", text: "Your urgency is decorative." },
    { kind: "dialogue", speakerId: "ant", note: "Already standing there.", text: "Delivery confirmed." },
    {
      kind: "dialogue",
      title: "WAR ROOM",
      speakerId: "admiralbulldog",
      text: "Mercenaries! The Syndicate is attacking Delivery Route 66!\nLaunch immediately!",
    },
    { kind: "dialogue", speakerId: "honeybadger", text: "Can I hit something expensive?" },
    { kind: "dialogue", speakerId: "elephant", text: "Please do not ask questions like that." },
    {
      kind: "card",
      title: "TITLE CARD",
      lines: ["STAR MERCENARIES 64", "PRESS START"],
    },
  ];
}

export function getStageOneLaunchSteps() {
  return [
    {
      kind: "card",
      title: "STAGE ONE — DELIVERY ROUTE 66",
      lines: ["LAUNCH SEQUENCE", "Ships fire from hangar into space.", "Music begins."],
    },
  ];
}

export function getStageOneColdOpenSteps() {
  return [
    {
      kind: "card",
      title: "HANGAR BAY",
      lines: [
        "DARK HANGAR BAY.",
        "ALARM LIGHTS FLASH RED.",
        "MISSION LAUNCH IN 30 SECONDS.",
        "",
        "CAMERA: SLOW CINEMATIC PAN ACROSS THE ROSTER.",
      ],
    },
    { kind: "dialogue", speakerId: "honeybadger", note: "(arms crossed)", text: "Which one of you parked in my launch lane?" },
    {
      kind: "dialogue",
      speakerId: "octopus",
      note: "(checking eight devices at once)",
      text: "Statistically, it was you.",
    },
    { kind: "dialogue", speakerId: "honeybadger", text: "Shut up, Elon." },
    { kind: "dialogue", speakerId: "octopus", note: "(stops)", text: "I am not Elon." },
    { kind: "dialogue", speakerId: "elephant", note: "(holding datapad)", text: "Technically he resembles a venture-backed cephalopod." },
    { kind: "dialogue", speakerId: "octopus", text: "Thank you.\nWait—that was also insulting." },
    { kind: "dialogue", speakerId: "mantisshrimp", note: "(adjusting expensive cuffs)", text: "Can we focus?\nMarkets collapse in twelve minutes." },
    { kind: "dialogue", speakerId: "honeybadger", text: "Nice speech, Peter Thiel shrimp." },
    { kind: "dialogue", speakerId: "mantisshrimp", text: "I am not Peter Thiel." },
    { kind: "dialogue", speakerId: "ant", note: "(carrying six boxes)", text: "Can we wrap this up?\nI have seventeen wars to automate." },
    { kind: "dialogue", speakerId: "honeybadger", text: "Quiet, Bezos ant." },
    { kind: "dialogue", speakerId: "ant", note: "(rapid clicking noises)", text: "I AM A QUEEN." },
    { kind: "dialogue", speakerId: "elephant", note: "(reading checklist)", text: "Before departure I require signatures confirming everyone has emotionally regulated." },
    { kind: "dialogue", speakerId: "honeybadger", text: "Nerd." },
    { kind: "dialogue", speakerId: "elephant", text: "That is not a signature." },
    { kind: "dialogue", speakerId: "octopus", note: "(pointing tentacle)", text: "Also why does everyone call me Altman, Elon, and Lex depending on lighting?" },
    { kind: "dialogue", speakerId: "mantisshrimp", text: "Because your face lacks commitment." },
    {
      kind: "narration",
      title: "ALERT SIREN",
      speakerId: "narrator",
      text: "WARNING: MARKET MAKER OMEGA APPROACHING",
      showModel: false,
    },
    { kind: "card", title: "(ALL PAUSE)", lines: [] },
    { kind: "dialogue", speakerId: "honeybadger", note: "(grinning)", text: "Finally.\nSomething I can hit." },
    { kind: "dialogue", speakerId: "ant", text: "Dibs on salvage rights." },
    { kind: "dialogue", speakerId: "elephant", text: "Absolutely not." },
    { kind: "dialogue", speakerId: "mantisshrimp", text: "Try not to embarrass yourselves publicly." },
    { kind: "dialogue", speakerId: "octopus", text: "Too late.\nWe formed a team." },
  ];
}

export function getStageOneBriefingSteps(selectedCharacterId) {
  const chosen = normalizeId(selectedCharacterId);
  const conditional = {
    honeybadger: "Insurance premiums have increased.",
    octopus: "Read all contracts before launch.",
    elephant: "Finally, an adult.",
    mantisshrimp: "I regret everything.",
    ant: "Good. Reliable labor.",
  }[chosen];

  return [
    {
      kind: "narration",
      title: "MISSION BRIEFING ROOM — STAGE ONE",
      note: "Large hologram of trade corridor. Enemy ships blinking red.",
      speakerId: "admiralbulldog",
      text: "Delivery Route 66 is under siege.\nProtect civilian freighters and eliminate hostile command presence.",
    },
    { kind: "dialogue", speakerId: "elephant", text: "I recommend caution." },
    { kind: "dialogue", speakerId: "honeybadger", text: "Rejected." },
    { kind: "dialogue", speakerId: "octopus", text: "I have acquired salvage rights in advance." },
    { kind: "dialogue", speakerId: "ant", text: "Efficient." },
    { kind: "dialogue", speakerId: "mantisshrimp", text: "This corridor was doomed at construction." },
    {
      kind: "dialogue",
      speakerId: "admiralbulldog",
      text: "Stop saying things like that.",
    },
    ...(conditional
      ? [
          {
            kind: "dialogue",
            speakerId: "admiralbulldog",
            text: conditional,
          },
        ]
      : []),
    {
      kind: "narration",
      title: "PRE-LAUNCH COUNTDOWN",
      speakerId: "logi7",
      text: "Probability of success: 43%.\nProbability of chaos: 99%.",
    },
    { kind: "dialogue", speakerId: "honeybadger", text: "Nice." },
  ];
}

export function getStageOneDebriefSteps(results = {}) {
  const objectiveSuccess = !!results?.objectiveSuccess;
  const civiliansRammed = Math.max(0, Number(results?.civiliansRammed) || 0);
  const routeName = results?.routeName ? String(results.routeName) : null;
  const rank = results?.rank ? String(results.rank).toUpperCase() : null;
  const medal = results?.medal ? String(results.medal).toUpperCase() : null;
  const kills = Math.max(0, Number(results?.kills) || 0);
  const miniBosses = Math.max(0, Number(results?.miniBosses) || 0);
  const damageTaken = Math.max(0, Number(results?.damageTaken) || 0);
  const scoreDelta = Math.max(0, Number(results?.scoreDelta) || 0);
  const cargoSaved = Math.max(0, Number(results?.cargoSaved) || 0);
  const cargoLost = Math.max(0, Number(results?.cargoLost) || 0);
  const cargoIntegrity = Math.max(0, Math.min(100, Number(results?.cargoIntegrity) || 0));
  const omegaPhases = Math.max(0, Number(results?.omegaPhases) || 0);

  const bonusLine =
    civiliansRammed > 0
      ? `BONUS FAILED: CIVILIANS RAMMED (${civiliansRammed})`
      : "BONUS: NO CIVILIANS RAMMED";
  const objectiveLine = objectiveSuccess ? "BONUS OBJECTIVE: SUCCESS" : "BONUS OBJECTIVE: FAILED";
  const routeLine = routeName ? `ROUTE UNLOCKED: ${routeName.toUpperCase()}` : null;
  const rankLine = rank ? `RANK: ${rank}` : null;
  const medalLine = medal ? `MEDAL: ${medal}` : null;
  const hitLine = kills ? `HITS: ${kills}` : null;
  const miniBossLine = miniBosses ? `MINI-BOSS CLEAR: ${miniBosses}` : null;
  const cargoLine = `CONVOY: ${cargoSaved} SAVED / ${cargoLost} LOST`;
  const cargoIntegrityLine = `CARGO INTEGRITY: ${Math.round(cargoIntegrity)}%`;
  const omegaLine = omegaPhases ? `OMEGA PHASES BROKEN: ${omegaPhases}/2` : null;
  const damageLine = `DAMAGE TAKEN: ${Math.round(damageTaken)}`;
  const scoreLine = `CONTRACT VALUE: $${Math.round(scoreDelta).toLocaleString()}`;

  return [
    {
      kind: "narration",
      title: "POST-MISSION DEBRIEF",
      speakerId: "admiralbulldog",
      text: "Outstanding work, mercenaries.\nTrade corridor secured.",
    },
    { kind: "dialogue", speakerId: "elephant", text: "Barely." },
    { kind: "dialogue", speakerId: "octopus", text: "I invoiced them during combat." },
    { kind: "dialogue", speakerId: "mantisshrimp", text: "Victory is temporary accounting." },
    { kind: "dialogue", speakerId: "admiralbulldog", text: "Stop saying things like that." },
    { kind: "dialogue", speakerId: "ant", text: "Package delivered." },
    { kind: "dialogue", speakerId: "honeybadger", text: "What are we crashing into next?" },
    {
      kind: "card",
      title: "STAGE CLEAR",
      lines: [
        "MISSION COMPLETE",
        rankLine,
        medalLine,
        hitLine,
        miniBossLine,
        cargoLine,
        cargoIntegrityLine,
        omegaLine,
        scoreLine,
        damageLine,
        "EQUITY GAINED: +17%",
        bonusLine,
        objectiveLine,
        routeLine,
      ].filter(Boolean),
    },
  ];
}
